// ================================================
// SERIALIZATION/DESERIALIZATION HELPERS
// ================================================

import {
  deckIndex,
  Message,
  Opcode,
  Packet,
  pileIndex,
  slotIndex,
} from "./types";

export function packetToArrayBuffer(p: Packet): DataView {
  const buf = new DataView(new ArrayBuffer(12));
  const msg = p.message;
  buf.setUint8(0, p.tickAdjustmentMs);
  buf.setUint32(4, p.tick);
  buf.setUint8(8, msg.opcode);
  switch (msg.kind) {
    case "uncover":
      buf.setUint8(9, msg.srcDeck);
      return buf;
    case "select":
      buf.setUint8(9, msg.slot);
      return buf;
    case "moveStart":
    case "moveSuccess":
    case "moveFail":
      buf.setUint8(9, msg.srcSlot);
      buf.setUint8(10, msg.dstPile);
      return buf;
    case "stressResult":
      buf.setUint8(9, msg.winnerId);
      return buf;
    case "seedState":
      buf.setUint32(8, msg.seed);
      buf.setUint8(8, msg.opcode); // overwrite high 8 bit again
      return buf;
    case "synchronize":
      buf.setUint32(8, msg.sequenceNumber);
      buf.setUint8(8, msg.opcode); // overwrite high 8 bit again
      return buf;
    case "stress":
    case "start":
    case "winner":
      buf.setUint8(9, msg.playerId);
      return buf;
    case "stuck":
    case "endStress":
    case "endStuck":
      return buf;
  }
}

export function toPacket(data: ArrayBuffer): Packet {
  const view: DataView = new DataView(data);
  const tickAdjustmentMs: number = view.getInt8(0);
  const tick: number = view.getUint32(4);
  const opcode: Opcode = view.getUint8(8);

  let message: Message;
  switch (opcode) {
    case Opcode.Uncover:
      message = {
        kind: "uncover",
        opcode: opcode,
        srcDeck: view.getUint8(9) as deckIndex,
      };
      break;
    case Opcode.Select:
      message = {
        kind: "select",
        opcode,
        slot: view.getUint8(9) as slotIndex,
      };
      break;
    case Opcode.MoveStart:
      message = {
        kind: "moveStart",
        opcode,
        srcSlot: view.getUint8(9) as slotIndex,
        dstPile: view.getUint8(10) as pileIndex,
      };
      break;
    case Opcode.MoveSuccess:
      message = {
        kind: "moveSuccess",
        opcode,
        srcSlot: view.getUint8(9) as slotIndex,
        dstPile: view.getUint8(10) as pileIndex,
      };
      break;
    case Opcode.MoveFail:
      message = {
        kind: "moveFail",
        opcode,
        srcSlot: view.getUint8(9) as slotIndex,
        dstPile: view.getUint8(10) as pileIndex,
      };
      break;
    case Opcode.StressResult:
      message = {
        kind: "stressResult",
        opcode,
        winnerId: view.getUint8(9) as 0 | 1,
      };
      break;
    case Opcode.SeedState:
      message = {
        kind: "seedState",
        opcode,
        seed: view.getUint32(8) & 0x00ffffff,
      };
      break;
    case Opcode.Synchronize:
      message = {
        kind: "synchronize",
        opcode,
        sequenceNumber: view.getUint32(8) & 0x00ffffff,
      };
      break;
    case Opcode.Stress:
      message = {
        kind: "stress",
        opcode,
        playerId: view.getUint8(9) as 0 | 1,
      };
      break;
    case Opcode.Stuck:
      message = {
        kind: "stuck",
        opcode,
      };
      break;
    case Opcode.Start:
      message = {
        kind: "start",
        opcode,
        playerId: view.getUint8(9) as 0 | 1,
      };
      break;
    case Opcode.Winner:
      message = {
        kind: "winner",
        opcode,
        playerId: view.getUint8(9) as 0 | 1,
      };
      break;
    case Opcode.EndStress:
      message = {
        kind: "endStress",
        opcode,
      };
      break;
    case Opcode.EndStuck:
      message = {
        kind: "endStuck",
        opcode,
      };
      break;
  }
  return {
    tickAdjustmentMs,
    tick,
    message,
  };
}
